import type { AddDistributorUserBody } from '@si/types';
import { post } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

export function useAddDistributorUser() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: (params: AddDistributorUserBody) =>
      post({
        url: `/distributors/${params.distributorId}/users`,
        body: { ...params },
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.getDistributors }),
  });

  const addDistributorUser = useCallback(
    (params: AddDistributorUserBody) => mutate(params),
    [mutate]
  );

  return {
    addDistributorUser,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
